import { ApplicationRef, createComponent, EnvironmentInjector, inject, Injectable, Type } from '@angular/core';

import { ModalBase } from '../../shared/modals/modal-base';

@Injectable()
export class ModalService {
  private readonly applicationRef = inject(ApplicationRef);
  private readonly injector = inject(EnvironmentInjector);

  openDialog<T extends ModalBase>(modal: Type<T>, inputs?: Map<string, unknown>): T {
    const modalHostElement = document.createElement('div');
    const modalRef = createComponent(modal, {
      environmentInjector: this.injector,
      hostElement: modalHostElement,
    });

    if (inputs) {
      inputs.forEach((value, key) => {
        modalRef.setInput(key, value);
      });
    }

    this.applicationRef.attachView(modalRef.hostView);

    modalRef.instance.closed.subscribe(() => {
      document.body.removeChild(modalHostElement);
      this.applicationRef.detachView(modalRef.hostView);
    });

    document.body.appendChild(modalHostElement);
    return modalRef.instance;
  }
}
